module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/commons/templates/ActionLogShowMoreBtn.ejs -->\n<div class="margin-bottom-large display-inline-block">\n    <button class="js-show-more-btn btn btn-primary btn-large ladda-button"\n            data-style="swap">\n        <i class="fa fa-arrow-down"></i> Show More\n    </button>\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/commons/templates/ActionLogShowMoreBtn.ejs
// module id = 807
// module chunks = 1